import axios from 'axios';
import { Http } from '../http/http';

class SettingsHttp extends Http {
  public async get() {
    const response = await axios.get<AppSettings>('/api/settings');
    return response.data;
  }
}

export const settingsHttp = new SettingsHttp();
